import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { Flex } from '../../component-library';
import { DefaultButton } from '../../components';
import { usePostMessage } from '../../context/messageContext';

const QuadrantFlex = styled(Flex)`
  width: 50vw;
  height: 50vh;
  padding: 4rem;
  cursor: ${(props) => (props.showQuadrants ? 'pointer' : 'auto')};

  &:hover {
    background-color: ${(props) => (props.showQuadrants ? 'rgba(0, 0, 0, 0.2)' : null)};
  }
`;

const CircleOpeningInputs = ({ showQuadrants, showButtons, keyboardInput }) => {
  const [quadrantBorder, setQuadrantBorder] = useState('none');
  const postMessage = usePostMessage();

  useEffect(() => {
    if (showQuadrants) {
      setQuadrantBorder('1px solid red');
    }
  }, [showQuadrants]);

  const handleClick = (quadrantClicked) => {
    return postMessage({ type: 'patientQuadrantResponse', content: quadrantClicked });
  };

  useEffect(() => {
    if (keyboardInput) {
      const handleKeyboardInput = (e) => {
        if (+e.key > 0 && +e.key < 5) {
          postMessage({ type: 'patientQuadrantResponse', content: +e.key });
        }
      };

      window.addEventListener('keydown', handleKeyboardInput);
      return () => window.removeEventListener('keydown', handleKeyboardInput);
    }
  }, [postMessage, keyboardInput]);

  return (
    <Flex flexWrap='wrap' style={{ position: 'absolute' }} width='100vw'>
      {[1, 2, 3, 4].map((quadrant) => {
        return (
          <QuadrantFlex
            borderBottom={quadrant < 3 ? quadrantBorder : 0}
            borderRight={quadrant % 2 ? quadrantBorder : 0}
            justifyContent={!(quadrant % 2) ? 'flex-end' : 'flex-start'}
            alignItems={quadrant < 3 ? 'flex-start' : 'flex-end'}
            id={`quadrant-${quadrant}`}
            key={`quadrant-${quadrant}`}
            onClick={showQuadrants ? () => handleClick(quadrant) : null}
            showQuadrants={showQuadrants}
          >
            <DefaultButton
              text={quadrant}
              bg='teal'
              disabled={!showButtons}
              width='4rem'
              height='4rem'
              fontSize='3rem'
              id={`quadrant-button-${quadrant}`}
              onClick={() => handleClick(quadrant)}
            />
          </QuadrantFlex>
        );
      })}
    </Flex>
  );
};

export default CircleOpeningInputs;
